import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { TablePagination, IconButton, Tooltip } from '@material-ui/core';
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';

function TablePaginationActions(props) {
  var className = props.className,
      page = props.page,
      onChangePage = props.onChangePage,
      backIconButtonProps = props.backIconButtonProps,
      nextIconButtonProps = props.nextIconButtonProps;

  var handleFirstPageButtonClick = function handleFirstPageButtonClick(event) {
    onChangePage(event, 0);
  };

  var handleBackButtonClick = function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  };

  return React.createElement("div", {
    className: className
  }, React.createElement(Tooltip, {
    title: "\u041F\u0435\u0440\u0432\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, React.createElement("span", null, React.createElement(IconButton, {
    onClick: handleFirstPageButtonClick,
    disabled: page === 0,
    color: 'inherit',
    "aria-label": "\u041F\u0435\u0440\u0432\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, React.createElement(FirstPage, null)))), React.createElement(Tooltip, {
    title: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, React.createElement("span", null, React.createElement(IconButton, Object.assign({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: 'inherit',
    "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, backIconButtonProps), React.createElement(KeyboardArrowLeft, null)))), React.createElement(Tooltip, {
    title: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, React.createElement("span", null, React.createElement(IconButton, Object.assign({
    onClick: handleNextButtonClick,
    color: 'inherit',
    "aria-label": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, nextIconButtonProps), React.createElement(KeyboardArrowRight, null)))));
}

function TablePaginationSlimActions(props) {
  var className = props.className,
      page = props.page,
      onChangePage = props.onChangePage,
      backIconButtonProps = props.backIconButtonProps,
      nextIconButtonProps = props.nextIconButtonProps;

  var handleFirstPageButtonClick = function handleFirstPageButtonClick(event) {
    onChangePage(event, 0);
  };

  var handleBackButtonClick = function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  };

  return React.createElement("div", {
    className: className
  }, React.createElement(Tooltip, {
    title: "\u041F\u0435\u0440\u0432\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, React.createElement("span", null, React.createElement(IconButton, {
    onClick: handleFirstPageButtonClick,
    disabled: page === 0,
    color: 'inherit',
    "aria-label": "\u041F\u0435\u0440\u0432\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    size: 'small'
  }, React.createElement(FirstPage, {
    fontSize: 'small'
  })))), React.createElement(Tooltip, {
    title: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, React.createElement("span", null, React.createElement(IconButton, Object.assign({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: 'inherit',
    "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    size: 'small'
  }, backIconButtonProps), React.createElement(KeyboardArrowLeft, {
    fontSize: 'small'
  })))), React.createElement(Tooltip, {
    title: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
  }, React.createElement("span", null, React.createElement(IconButton, Object.assign({
    onClick: handleNextButtonClick,
    color: 'inherit',
    "aria-label": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    size: 'small'
  }, nextIconButtonProps), React.createElement(KeyboardArrowRight, {
    fontSize: 'small'
  })))));
}

var GridFoot =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridFoot, _React$Component);

  function GridFoot() {
    var _this;

    _classCallCheck(this, GridFoot);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridFoot).apply(this, arguments));
    _this.internalPage = 0;

    _this.changePage = function (_event, newPage) {
      var _this$props = _this.props,
          rowsPerPage = _this$props.rowsPerPage,
          onChangePage = _this$props.onChangePage,
          currentPage = _this$props.currentPage;
      var direction;
      var page;

      if (newPage === 0) {
        direction = 'first';
        page = 0;
      } else if (newPage < _this.internalPage) {
        direction = 'prev';
        page = currentPage - 1;
      } else {
        direction = 'next';
        page = currentPage + 1;
      }

      if (page < 0) page = 0;
      onChangePage(page, rowsPerPage, direction);
    };

    _this.changeRowsPerPage = function (event) {
      _this.props.onChangePage(0, parseInt(event.target.value), 'first');
    };

    return _this;
  }

  _createClass(GridFoot, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          countItems = _this$props2.countItems,
          currentPage = _this$props2.currentPage,
          rowsPerPage = _this$props2.rowsPerPage,
          rowsPerPageOptions = _this$props2.rowsPerPageOptions,
          dataLinks = _this$props2.dataLinks,
          classes = _this$props2.classes,
          slim = _this$props2.slim;
      var isHateoasStyle = !!dataLinks;
      var count = countItems || 0;
      this.internalPage = currentPage;
      var nextButtonDisabled = this.internalPage >= Math.ceil(count / rowsPerPage) - 1;
      var hateoasFrom = 0;
      var hateoasTo = 0;

      if (isHateoasStyle) {
        this.internalPage = !dataLinks.prev ? 0 : 2;
        count = (this.internalPage + 1) * rowsPerPage;
        nextButtonDisabled = !dataLinks.next;
        hateoasFrom = currentPage * rowsPerPage + 1;
        hateoasTo = currentPage * rowsPerPage + (countItems < rowsPerPage ? countItems : rowsPerPage);
        if (hateoasTo === 0) hateoasFrom = 0;
      }

      return React.createElement(TablePagination, {
        rowsPerPageOptions: rowsPerPageOptions,
        component: 'div',
        count: count,
        rowsPerPage: rowsPerPage,
        page: this.internalPage,
        labelRowsPerPage: 'Показывать по:',
        labelDisplayedRows: function labelDisplayedRows(_ref) {
          var from = _ref.from,
              to = _ref.to,
              count = _ref.count,
              page = _ref.page;
          return isHateoasStyle ? "\u0421\u0442\u0440. ".concat(currentPage + 1, " (").concat(hateoasFrom, "-").concat(hateoasTo, ")") : "\u0421\u0442\u0440. ".concat(page + 1, " (").concat(from, "-").concat(to, " \u0438\u0437 ").concat(count, ")");
        },
        onChangePage: this.changePage,
        onChangeRowsPerPage: this.changeRowsPerPage,
        ActionsComponent: slim ? TablePaginationSlimActions : TablePaginationActions,
        nextIconButtonProps: {
          disabled: nextButtonDisabled
        },
        classes: slim ? {
          toolbar: classes.footToolbarSlim,
          caption: classes.footCaptionSlim,
          input: classes.footInputSlim
        } : undefined
      });
    }
  }]);

  return GridFoot;
}(React.Component);

GridFoot.defaultProps = {
  rowsPerPageOptions: [20, 50, 100],
  nextButtonDisabled: false
};
export default GridFoot;